/**
 * @desc 出库
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockOrderOutboundCmd, options?: any) {
  return updateResponse(
    http(URL + `/stock/outbound`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
